import React from "react";

export default function Subtraction_Operator() {
  return <div>Excel_Arithmetic_Subtraction_Operator</div>;
}
